export const normalizeValue = value => typeof value === 'string' ? value.trim() : value;
